import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteOrganization } from '../../../entities/org';
import { identityErrorMessage } from '../../../shared/api/identity-error';
import { Button } from '../../../shared/ui/button';
import { ConfirmDialog } from '../../../shared/ui/confirm-dialog';
import { toast } from '../../../shared/ui/sonner';

/** Owner only (`org.delete`). A soft delete behind a typed-name confirmation (Q32). */
export function DeleteOrgButton({
  org,
  onDeleted,
}: {
  org: { id: string; name: string };
  onDeleted: () => void;
}) {
  const { t } = useTranslation('org');
  const remove = useDeleteOrganization(org.id);
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="danger" onClick={() => setOpen(true)}>
        {t('settings.delete.action')}
      </Button>
      <ConfirmDialog
        open={open}
        onOpenChange={setOpen}
        title={t('settings.delete.confirmTitle', { org: org.name })}
        description={t('settings.delete.confirmBody')}
        confirmLabel={t('settings.delete.confirm')}
        cancelLabel={t('settings.delete.cancel')}
        requireText={org.name}
        requireTextLabel={t('settings.delete.typeName', { name: org.name })}
        errorMessage={identityErrorMessage}
        onConfirm={async () => {
          await remove.mutateAsync();
          toast.success(t('settings.delete.done'));
          onDeleted();
        }}
      />
    </>
  );
}
